import { Dispatch, SetStateAction, useState } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, FormControlLabel, Radio, RadioGroup, FormControl, } from '@mui/material'

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>
}

export default function AddCharges({ open, onClose, setOpen }: AddCategoryModalProps) {
  const [paidOption, setPaidOption] = useState("female");
  return (
    <Modal
      className="modal add_charge_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center ">
            <h2>Do you want charges?</h2>
            <div className="btn-close" tabIndex={0} role="button" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group ">
              <FormControl className="paid_radio">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={paidOption}
                  onChange={(e) => setPaidOption(e.target.value)}

                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {paidOption !== "male" && (
              <div className="control_group w_100">
                <label htmlFor='defaultCharges'>Default Charges</label>
                <TextField id="defaultCharges" aria-labelledby="defaultChargesLabel" placeholder="Enter Default Charges" hiddenLabel fullWidth inputProps={{
                  'aria-label': 'Default Charges',
                }} />
              </div>
            )}
            <div className="footer_btn_flex">

              <Button className="btn btn_primary" role='button' tabIndex={0} onClick={() => setOpen(false)}>Submit</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal >
  )
}
